import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/emailVerification/messages";

function* resendVerificationEmail() {
  const { success, data, error } = yield* makeRequest.post(
    "/email_verification/resend",
    {},
    { noEmailVerifiedRedirect: true },
  );

  if (success && data) {
    yield put(
      actions.newSuccessEvent({
        message: messages.RESEND_VERIFICATION_SUCCESS,
        payload: {
          event: messages.RESEND_VERIFICATION_SUCCESS_EVENT,
        },
      }),
    );
  } else if (error) {
    if (error.message === messages.RESEND_VERIFICATION_ALREADY_VERIFIED) {
      yield put(
        actions.newSuccessEvent({
          message: messages.RESEND_VERIFICATION_ALREADY_VERIFIED,
          payload: {
            event: messages.RESEND_VERIFICATION_ALREADY_VERIFIED_EVENT,
          },
        }),
      );
    } else {
      return getErrorActions({
        error: {
          ...error,
          event: messages.RESEND_VERIFICATION_ERROR_EVENT,
        },
      });
    }
  }

  return null;
}

export default resendVerificationEmail;
